export default __webpack_public_path__ + "static/331-154291eaeb0625f0d990d3ce6e594a45.mp4";